import {
  IonButton,
  IonButtons,
  IonCard,
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonSpinner,
  IonText,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { personCircleOutline, trashOutline } from "ionicons/icons";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../../store/rootReducer";
import { setDeselectAllPeople, setDeselectPeople } from "../../../store/MassNotification";
import { selectPeopleSelected } from "../../../store/MassNotification/selectors/selectPeopleSelected";

const avatarStyle = {
  verticalAlign: "middle",
};

export const PeopleSelected = () => {
  const dispatch = useDispatch();
  const selectedPeople = useSelector(selectPeopleSelected);
  const findPeopleStatus = useSelector(
    (state: RootState) => state.massNotification.findPeopleStatus
  );

  return (
    <IonCard style={{ height: "75vh" }} class="ion-no-margin">
      <IonToolbar color="primary">
        <IonTitle size="small" style={{ fontWeight: 500 }}>
          Seleccionados ({selectedPeople.length})
        </IonTitle>
        <IonButtons slot="end">
          {!!selectedPeople.length && (
            <IonButton
              fill="solid"
              color="danger"
              onClick={() => {
                dispatch(setDeselectAllPeople());
              }}
              size="small"
            >
              <small>Quitar todos</small>
              <IonIcon icon={trashOutline} slot="end" />
            </IonButton>
          )}
        </IonButtons>
      </IonToolbar>
      <IonContent style={{ overlay: "scroll", height: "68vh" }}>
        <IonList>
          {findPeopleStatus === "succeeded" &&
            selectedPeople.map((item) => (
              <IonItem key={item.id}>
                <IonLabel className="ion-hide-md-up" text-wrap>
                  <h5 style={{ fontWeight: 700 }}>
                    <IonIcon icon={personCircleOutline} style={avatarStyle}></IonIcon>{" "}
                    <IonText color="primary" style={avatarStyle}>
                      {item.name}
                    </IonText>
                  </h5>
                  <IonText color="medium" style={{ fontWeight: 400 }}>
                    <small>{item.role}</small>
                    <br />
                    <small>
                      {item.location.name} - {item.code}
                    </small>
                  </IonText>
                </IonLabel>
                <IonLabel className="ion-hide-md-down" text-wrap>
                  <h3 style={{ fontWeight: 700 }}>
                    <IonIcon icon={personCircleOutline} style={avatarStyle}></IonIcon>{" "}
                    <IonText color="primary" style={avatarStyle}>
                      {item.name}
                    </IonText>
                  </h3>
                  <IonText color="medium" style={{ fontWeight: 400 }}>
                    <small>{item.role}</small>
                    <br />
                    <small>
                      {item.location.name} - {item.code}
                    </small>
                  </IonText>
                </IonLabel>
                <IonButton
                  expand="block"
                  fill="clear"
                  onClick={() => {
                    dispatch(setDeselectPeople(item));
                  }}
                  size="default"
                >
                  <IonIcon icon={trashOutline} />
                </IonButton>
              </IonItem>
            ))}
          {findPeopleStatus === "pending" && (
            <p className="ion-text-center">
              <IonSpinner />
            </p>
          )}
        </IonList>
      </IonContent>
    </IonCard>
  );
};
